import template from './fileUploadsListItem.html';

export function FileUploadListItemViewModel(params) {

  var self = this;

  self.fileUpload = params.fileUpload;
  self.isReadOnly = params.isReadOnly;
  self.removeUpload = function () {
    params.removeUploadCallback(self.fileUpload);
  };
}

// The default export returns the component details object to register with KO
export default { viewModel: FileUploadListItemViewModel, template: template };